import { styled } from '@mui/material';
import { Theme } from '@mui/system';

export const ListItem = styled('ul')(({ theme }: { theme: Theme }) => ({
  color: theme.palette.secondary.main,
  lineHeight: '26px',
  listStyle: 'none',
  marginBottom: '15px'
}));
